<template><div><h1>VUX V2.5.3 released</h1>
<h2><a href="/en/components/group.html">Group</a></h2>
<ul><li>[enhance] prop:labelAlign support justify #1574</li>
</ul>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[fix] Fix label style being overwrite after importing x-textarea #1696</li>
</ul>
<h2><a href="/en/components/swiper.html">Swiper</a></h2>
<ul><li>[fix] clear listTtwoLoopItem when list size !== 2 #1684 @weizs</li>
</ul>
<h2><a href="/en/components/x-dialog.html">XDialog</a></h2>
<ul><li>[feature] Add prop:show, supports the .sync modifier</li>
</ul>
<h2><a href="/en/components/x-header.html">XHeader</a></h2>
<ul><li>[feature] Add slot:overwrite-title #1669</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.3 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.3-118.vue?348f8323